import React from 'react';

import TableDisplay from './TableDisplay';

import {Data} from '../services/data-manager';
import { Modal } from 'react-bootstrap';
import Moment from 'react-moment';
import { pays } from '../config/globales';
import { notifyDanger, notifySuccess } from '../utils';
import Notification from 'react-notify-toast';
import ReactToPrint from 'react-to-print';

class Transactions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            transactions: [],
            page: 1,
            nbTransaction: 1,
            sizeTransaction: 50,
            transaction: null,
            showDetail: false,
            retrait: {
                pays: "",
                numero: "",
                idUtilisateur: 0,
                nom: "",
                beneficiaire: "",
                montant: 0,
                devise: "",
                idAgent: 0,
                credential: "",
                isRetrait: true,
                isApprovisionnement: false
            },
            recherche: {
                motCle: "",
                tri: "",
                dateDebut: "",
                dateFin: ""
            },
            showRetrait: false,
            loading: false,
            showConfirmationRetrait: false
        };
        this.getTransactions = this.getTransactions.bind(this);
        this.getDetailTransaction = this.getDetailTransaction.bind(this);
        this.showDetailModal = this.showDetailModal.bind(this);
        this.handleInputRetrait = this.handleInputRetrait.bind(this);
        this.showRetraitModal = this.showRetraitModal.bind(this);
        this.getClient = this.getClient.bind(this);
        this.sendRetrait = this.sendRetrait.bind(this);
        this.showConfirmationRetraitModal = this.showConfirmationRetraitModal.bind(this);
        this.getRetraitStatus = this.getRetraitStatus.bind(this);
        this.handleInputRecherche = this.handleInputRecherche.bind(this);
        this.handleRechercheForm = this.handleRechercheForm.bind(this);
    }
    componentDidMount() {
        let retrait = this.state.retrait;
        retrait.devise = this.props.auth.utilisateur.devise;
        retrait.idAgent = this.props.auth.utilisateur.id;
        retrait.credential = this.props.auth.credential;
        this.setState({retrait: retrait});
        this.getTransactions();
    }
    getTransactions(page=0) {
        if (page!==0) {
            this.setState({page: page});
        } else {
            page = this.state.page;
        }
        this.props.isLoading(true);
        let sOrder = "dateCreation DESC";
        if (this.state.recherche.tri!="") {
            sOrder = this.state.recherche.tri;
        }
        let sCondition = "";
        // Condition sur l'utilisateur connecté
        if (this.props.auth.utilisateur.type<6) sCondition = `idAgent="${this.props.auth.utilisateur.id}"`;
        else if (this.props.auth.utilisateur.type<10) sCondition = `idAgent IN (SELECT id FROM Utilisateur WHERE idPartenaire="${this.props.auth.utilisateur.idPartenaire}")`;
        else if (this.props.auth.utilisateur.type<30) sCondition = `idUtilisateur IN (SELECT id FROM Utilisateur WHERE pays="${this.props.auth.utilisateur.pays}")`;
        else sCondition = "1";
        // Condition sur la date de la transaction
        if (this.state.recherche.dateDebut!="" && this.state.recherche.dateFin!="") {
            sCondition += ` AND dateCreation BETWEEN "${this.state.recherche.dateDebut}" AND "${this.state.recherche.dateFin}"`;
        } else if (this.state.recherche.dateFin!="") {
            sCondition += ` AND dateCreation <= "${this.state.recherche.dateFin}"`;
        } else if (this.state.recherche.dateDebut!="") {
            sCondition += ` AND dateCreation >= "${this.state.recherche.dateDebut}"`;
        }
        // Conditions de la recherche
        if (this.state.recherche.motCle!="") {
            let motCle = this.state.recherche.motCle;
            motCle = motCle.toUpperCase();
            const tMotCle = motCle.replace(/'|,/g, " ").split(" ");
            let sAddCondition = "";
            for(const mot of tMotCle) {
                if (sAddCondition!="") sAddCondition += " AND ";
                sAddCondition += `(UPPER(nom) LIKE "%${mot}%" OR UPPER(prenom) LIKE "%${mot}%" OR UPPER(pays)="${mot}" OR UPPER(ville)="${motCle}")`;// OR devise="${mot}"
            }
            sCondition += ` AND (UPPER(idTransaction)="${motCle}" OR devise="${motCle}" OR type="${motCle}" OR status="${motCle}" OR idUtilisateur IN (SELECT id FROM Utilisateur WHERE ${sAddCondition}))`;
        }
        new Data()
        .get("Transaction", sCondition, "utilisateur", sOrder, page, this.state.sizeTransaction)
        .then(res => {
            this.setState({transactions: res.rows, nbTransaction: res.count});
        })
        .catch(err => {
            console.warn("Error : ", err);
        })
        .finally(() => {
            this.props.isLoading(false);
        });
        window.scrollTo(0,0);
    }
    getDetailTransaction(transaction) {
        this.setState({transaction: transaction}, () => {
            this.showDetailModal();
        });
    }
    showDetailModal(show=true) {
        this.setState({showDetail: show});
    }
    cancelTransaction(transaction) {
        window.confirm("Voulez vous vraiment supprimer la transaction "+transaction.idTransaction);
    }
    handleInputRetrait(event) {
        let target = event.target;
        const name = target.name;
        const value = target.value;
        let retrait = this.state.retrait;
        retrait[name] = value;
        this.setState({retrait: retrait}, () => {
            if ((name=="pays" || name=="numero") && (this.state.retrait.pays!="" && this.state.retrait.numero.length>6)) {
                this.getClient();
            }
        });
    }
    handleInputRecherche(event) {
        let target = event.target;
        const name = target.name;
        const value = target.value;
        let recherche = this.state.recherche;
        recherche[name] = value;
        this.setState({recherche: recherche});
    }
    showRetraitModal(show=true) {
        this.setState({showRetrait: show});
    }
    getClient() {
        new Data()
        .getOne("Utilisateur", `pays="${this.state.retrait.pays}" AND telephone="${this.state.retrait.numero}"`)
        .then(utilisateur => {
            let retrait = this.state.retrait;
            retrait.idUtilisateur = utilisateur.id;
            retrait.nom = utilisateur.nom;
            this.setState({retrait: retrait});
        })
        .catch(error => {
            let retrait = this.state.retrait;
            retrait.idUtilisateur = "";
            retrait.nom = "";
            this.setState({retrait: retrait});
        })
    }
    sendRetrait() {
        if (this.state.retrait.idAgent==0) {
            notifyDanger("Veuillez vous reconnecter avant d'effectuer cette opération.");
            return false;
        }
        if (this.state.retrait.idUtilisateur==0) {
            notifyDanger("Utilisateur introuvable. Veuillez choisir un pays et renseigner un numéro valide.");
            return false;
        }
        if (this.state.retrait.montant<=0) {
            notifyDanger("Montant incorrect.");
            return false;
        }
        if (this.state.retrait.beneficiaire.length<3) {
            notifyDanger("Veuillez renseigner un nom de bénéficiaire correct.");
            return false;
        }
        this.setState({loading: true});
        this.props.auth.refreshCredential();
        new Data()
        .exec("/partenaire/transaction", this.state.retrait)
        .then(res => {
            if (res.code==200) {
                notifySuccess("Transaction encours, en attente de confirmation.");
                this.showConfirmationRetraitModal(true);
                this.getRetraitStatus(res.transaction.idTransaction);
            } else {
                notifyDanger(res.message);
            }
        })
        .catch(error => {
            console.warn("Erreur : ", error);
            notifyDanger("Une erreur c'est produite. Vérifiez votre connexion et reessayez.");
        })
        .finally(() => {
            this.setState({loading: false, showRetrait: false});
        })
        return true;
    }
    showConfirmationRetraitModal(show=true) {
        this.setState({showConfirmationRetrait: show});
    }
    getRetraitStatus(idTransaction) {
        new Data()
        .exec("/partenaire/transaction/status", {
            credential: this.props.auth.credential,
            idAgent: this.props.auth.utilisateur.id,
            idTransaction: idTransaction
        })
        .then(res => {
            if (res.code==200) {
                if (res.status=="PENDING") {
                    setTimeout(this.getRetraitStatus, 5000, idTransaction);
                } else {
                    this.showConfirmationRetraitModal(false);
                    if (res.status=="SUCCESSFUL") {
                        window.alert(`La transaction à été validée par le client.\nVous pouvez payer le bénéficiaire.\nBénéficiaire : ${res.beneficiaire}\nMontant : ${Intl.NumberFormat().format(res.montant)} ${res.devise}`);
                        notifySuccess("La transaction à été confirmée par le payeur.");
                    } else {
                        notifyDanger("La transaction n'a pas été validée par le payeur.");
                    }
                }
            } else {
                this.showConfirmationRetraitModal(false);
                notifyDanger(res.message);
            }
        })
        .catch(error => {
            console.warn("Erreur : ", error);
            this.showConfirmationRetraitModal(false);
            notifyDanger("Une erreur c'est produite. Vérifiez votre connexion et reessayez.");
        })
    }
    handleRechercheForm(event) {
        event.preventDefault();
        this.getTransactions(this.state.page);
    }
    render() {
        return (
            <>
            <div className="container-fluid">
                <Notification options={{top: "100px"}} />
                <div className="row">
                    <div className="col-sm-12 my-3">
                        <div className="border p-3">
                            <form className="row" onSubmit={this.handleRechercheForm}>
                                <div className="col-6 col-md-4">
                                    <input className="form-control" type="text" name="motCle" placeholder="Recherche (ID transaction, nom, prénom, devise)" value={this.state.recherche.motCle} onChange={this.handleInputRecherche} />
                                </div>
                                <div className="col-6 col-md-2">
                                    <input className="form-control" type="date" name="dateDebut" placeholder="Début" value={this.state.recherche.dateDebut} onChange={this.handleInputRecherche} />
                                </div>
                                <div className="col-6 col-md-2">
                                    <input className="form-control" type="date" name="dateFin" placeholder="Fin" value={this.state.recherche.dateFin} onChange={this.handleInputRecherche} />
                                </div>
                                <div className="col-6 col-md-2">
                                    <select className="form-control" name="tri" value={this.state.recherche.motCle} onChange={this.handleInputRecherche}>
                                        <option value="">Ordre de tri</option>
                                        <option value="dateCreation ASC">Ordre croissant de date de transaction</option>
                                        <option value="dateCreation DESC">Ordre décroissant de date de transaction</option>
                                    </select>
                                </div>
                                <div className="col-12 col-md-2">
                                    <button className="btn btn-secondary btn-block" type="submit">
                                        <span className="d-none d-md-inline">Rechercher</span>
                                        <span className="d-inline d-md-none">Rechercher</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fluid" ref={(myRef) => {this.printableToPDF = myRef}}>
                <div className="row my-3">
                    <div className="col-sm-12 col-md-7">
                        <h3>Transactions [Page {this.state.page}/{(this.state.nbTransaction===0)?1:Math.ceil(this.state.nbTransaction/this.state.sizeTransaction)}]</h3>
                        {
                            ((this.state.recherche.motCle!="") || (this.state.recherche.dateDebut!="") || (this.state.recherche.dateFin!="")) &&
                            <h5>
                                Filtre : 
                                {(this.state.recherche.motCle!="")?<span> {this.state.recherche.motCle.toUpperCase()}, </span>:""}
                                {
                                    (this.state.recherche.dateDebut!="" && this.state.recherche.dateFin!="")
                                    ?
                                    <span> Du <Moment>{this.state.recherche.motCle.toUpperCase()}</Moment> au <Moment>{this.state.recherche.dateFin}</Moment></span>
                                    :
                                    (
                                        (this.state.recherche.dateDebut!="")
                                        ?
                                        <span> A partir de <Moment>{this.state.recherche.dateDebut}</Moment></span>
                                        :
                                        (
                                            (this.state.recherche.dateFin!="")
                                            ?
                                            <span> Limité au <Moment>{this.state.recherche.dateFin}</Moment></span>
                                            :
                                            ""
                                        )
                                    )
                                }
                            </h5>
                        }
                    </div>
                    <div className="col-sm-12 col-md-5 text-right">
                        <ReactToPrint 
                            filename="africpay-transactions.pdf"
                            content={() => this.printableToPDF}
                            trigger={() => <button className="btn btn-secondary">Imprimer</button>}
                        />
                        {
                            (this.props.auth.utilisateur.type<10) &&
                            <button className="btn btn-primary ml-1" onClick={this.showRetraitModal}>Faire un retrait</button>
                        }
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12 mb-3">
                        <TableDisplay 
                            tableStriped={true}
                            tableHover={true}
                            thead="dark"
                            titles={["ID", "CLIENT", "OPERATION", "MONTANT", "DEVISE", "DATE ET HEURE", "ETAT"]}
                            indices={["id", ["utilisateur.nom","utilisateur.prenom"], "type", "montant", "devise", "dateCreation", "status"]}
                            data={this.state.transactions}
                            actions={[
                                {caption: <i className='fa fa-list'></i>, className:"btn btn-sm btn-primary mr-1", onClick:this.getDetailTransaction}
                            ]}
                            withPaging={true}
                            pagingTheme="primary"
                            nb={this.state.nbTransaction}
                            size={this.state.sizeTransaction}
                            current={this.state.page}
                            onChangePage= {this.getTransactions}
                            withFooter={true} />
                    </div>
                </div>
                {(this.state.transaction) &&
                <Modal show={this.state.showDetail} onHide={() => {this.showDetailModal(false)}} className="mt-5">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Détails de la transaction #{this.state.transaction.id}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="mx-3">
                            <table className="table table-sm">
                                <tbody>
                                    <tr className="row">
                                        <td className="col-sm-5">ID : </td>
                                        <td className="col-sm-7">{this.state.transaction.id}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">ID de Traitement : </td>
                                        <td className="col-sm-7">{this.state.transaction.idTransaction}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">ID de Traitement 2 : </td>
                                        <td className="col-sm-7">{this.state.transaction.idTransaction2}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">ID de Traitement 3 : </td>
                                        <td className="col-sm-7">{this.state.transaction.idTransaction3}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-5">Type : </td>
                                        <td className="col-7">{this.state.transaction.type}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-5">Client : </td>
                                        <td className="col-7">{this.state.transaction.utilisateur.nom} {this.state.transaction.utilisateur.prenom}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-5">Bénéficiaire : </td>
                                        <td className="col-7">{this.state.transaction.beneficiaire}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-5">Numéro de téléphone : </td>
                                        <td className="col-7">{this.state.transaction.numero}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-5">Montant : </td>
                                        <td className="col-7">{Intl.NumberFormat().format(this.state.transaction.montant)} {this.state.transaction.devise}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-5">Opérateur : </td>
                                        <td className="col-7">{this.state.transaction.operateur}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-5">Pays : </td>
                                        <td className="col-7">{this.state.transaction.pays}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-5">Valeur réelle : </td>
                                        <td className="col-7">{Intl.NumberFormat().format(this.state.transaction.valeurReelle)} {this.props.auth.utilisateur.devise}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-5">Date : </td>
                                        <td className="col-7"><Moment format="DD/MM/YYYY à HH:mm">{this.state.transaction.dateCreation}</Moment></td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-5">Etat : </td>
                                        <td className="col-7">
                                            <span className={"badge bg-"+((this.state.transaction.status=="SUCCESSFUL")?"success":((this.state.transaction.status=="FAILED")?"danger":"warning"))}>{this.state.transaction.status}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </Modal.Body>
                    <Modal.Footer></Modal.Footer>
                </Modal>
                }
                <Modal show={this.state.showRetrait} className="mt-5" onHide={() => {this.showRetraitModal(false)}}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Nouveau retrait
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form-group">
                            <label htmlFor="pays">Pays</label>
                            <select className="form-control" id="pays" name="pays" onChange={(e) => this.handleInputRetrait(e)}>
                                <option value="">Choisissez le pays</option>
                                {( pays.map(p => <option value={ p.name } key={'pays-'+p.name}>{ p.name }</option> ) )}
                            </select>
                        </div>
                        <div className="form-group">
                            <label htmlFor="numero">Numéro de téléphone</label>
                            <input className="form-control" id="numero" name="numero" value={this.state.retrait.numero} onChange={(e) => this.handleInputRetrait(e)} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="idUtilisateur">Code client</label>
                            <input className="form-control" id="idUtilisateur" name="idUtilisateur" value={this.state.retrait.idUtilisateur} disabled />
                        </div>
                        <div className="form-group">
                            <label htmlFor="nom">Nom du client</label>
                            <input className="form-control" id="nom" name="nom" value={this.state.retrait.nom} disabled />
                        </div>
                        <div className="form-row">
                            <div className="form-group col-8">
                                <label htmlFor="montant">Montant</label>
                                <input type="number" name="montant" id="montant" className="form-control" value={this.state.retrait.montant} onChange={(e) => this.handleInputRetrait(e)} required />
                            </div>
                            <div className="form-group col-4">
                                <label htmlFor="devise">Devise</label>
                                <input type="text" name="devise" id="devise" className="form-control" value={this.state.retrait.devise} disabled />
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="beneficiaire">Bénéficiaire</label>
                            <input type="text" name="beneficiaire" value={this.state.retrait.beneficiaire} id="beneficiaire" className="form-control" onChange={(e) => this.handleInputRetrait(e)} required />
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="text-right">
                        <button className="btn btn-secondary" onClick={() => {this.showRetraitModal(false)}}>Quitter</button>
                        <button className="btn btn-success" disabled={this.state.loading} onClick={this.sendRetrait}>Valider</button>
                    </Modal.Footer>
                </Modal>
                <Modal show={this.state.showConfirmationRetrait} onHide={() => {}} className="mt-5">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Nouveau retrait
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <h3>
                            En attente de confirmation...
                        </h3>
                    </Modal.Body>
                    <Modal.Footer className="text-right">
                        <a className="btn btn-warning" href="/transactions" target="_blank">Continuer les opérations</a>
                    </Modal.Footer>
                </Modal>
            </div>
        </>
        );
    }
}

export default Transactions;